import { Box } from '@pocketlaw/tetris';
export function ActivityLog(props) {
    const { children } = props;
    return <Box flexDirection="column">{children}</Box>;
}
